<!--
    扩展AntD Vue的TimePicker组件，接受传入一个startTime，让选择框只能选择startTime时间之后的值
 -->
<template>
  <a-time-picker
    v-bind="$attrs"
    :value="currentTime"
    :disabled-hours="customDisabledHours"
    :disabled-minutes="customDisabledMinutes"
    :disabled-seconds="customDisabledSeconds"
    @change="handleChange"
  />
</template>

<script>
import { TimePicker as AntTimePicker } from "ant-design-vue";
// import moment from 'moment';

export default {
    name: "EndTimePicker",
    extends: AntTimePicker,
    props: {
        startTime: {
            type: Date,
            default: null
        },
        value: {
            type: [Object, String],
            default: null
        }
    },
    data () {
        return {
            currentTime: this.value || null
        }
    },
    watch: {
        // 当外部传入的值发生变化时，更新 currentTime
        value: function (newValue) {
            console.log('newValue:', newValue)
            this.currentTime = newValue || null
        }
    },
    methods: {
        // 根据传入的时间值计算禁用的小时
        customDisabledHours () {
            const value = this.startTime || this.defaultValue;
            if (value) {
                const currentHour = value.getHours();
                return Array.from({ length: currentHour }, (_, index) => index);
            }
            return [];
        },
        // 根据传入的时间值和当前选择的小时计算禁用的分钟
        customDisabledMinutes (selectedHour) {
            const value = this.startTime || this.defaultValue;
            if (value && selectedHour === value.getHours()) {
                const currentMinute = value.getMinutes();
                return Array.from({ length: currentMinute }, (_, index) => index);
            }
            return [];
        },
        // 根据传入的时间值、当前选择的小时和分钟计算禁用的秒钟
        customDisabledSeconds (selectedHour, selectedMinute) {
            const value = this.startTime || this.defaultValue;
            if (
                value &&
                selectedHour === value.getHours() &&
                selectedMinute === value.getMinutes()
            ) {
                const currentSecond = value.getSeconds();
                return Array.from({ length: currentSecond }, (_, index) => index);
            }
            return [];
        },
        handleChange (time, timeStr) {
            // 在change事件中调用Ant Design Vue的change事件
            console.log(arguments)
            this.$emit("input", time, timeStr);
            this.$emit("change", time, timeStr);
        }
    }
};
</script>

<style scoped>
/* 可以根据需要添加样式 */
</style>
